import Marquee from "react-fast-marquee";

const words = [
    "MANUFACTURING",
    "SECURITY",
    "HOUSEKEEPING",
    "DRIVERS",
    "OFFICE STAFF",
    "TECHNICIANS",
    "LOGISTICS",
    "FRESHERS WELCOME",
];

export const Ribbon = () => {
    return (
        <div
            data-testid="marquee-ribbon"
            className="border-y border-white/10 bg-[#0A0F1C] py-6 relative z-10"
        >
            <Marquee speed={45} gradient={false} autoFill>
                {words.map((w, i) => (
                    <span key={i} className="mx-8 inline-flex items-center gap-8">
                        <span className="font-display text-3xl sm:text-4xl font-extrabold text-stroke uppercase">
                            {w}
                        </span>
                        <span className="h-2.5 w-2.5 rounded-full bg-[#F47B20]" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
};
